export default "__VITE_ASSET__hIH7z4el__"